/* eslint-disable import/prefer-default-export */
export const GET_HELPDESK_TICKETS = 'GET_HELPDESK_TICKETS';
